import { render, staticRenderFns } from "./no-permission.vue?vue&type=template&id=e2aa61dc&scoped=true"
import script from "./no-permission.vue?vue&type=script&lang=js"
export * from "./no-permission.vue?vue&type=script&lang=js"
import style0 from "./no-permission.vue?vue&type=style&index=0&id=e2aa61dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2aa61dc",
  null
  
)

export default component.exports